import React from "react";
import { cn } from "@/lib/utils";

export const ReputationCard = ({ metric, accent = "#00F0FF", className = "" }) => (
  <div className={cn("glass rounded-2xl p-5", className)} data-testid={`rep-${metric.key.toLowerCase().replace(/\s+/g, "-")}`}>
    <div className="flex items-center justify-between">
      <span className="font-heading text-sm font-bold text-white">{metric.key}</span>
      <span className="font-mono text-lg font-extrabold" style={{ color: accent }}>{metric.value}</span>
    </div>
    <div className="mt-3 h-1.5 w-full overflow-hidden rounded-full bg-white/5">
      <div className="h-full rounded-full" style={{ width: `${metric.value}%`, background: `linear-gradient(90deg, ${accent}, #7C3AED)` }} />
    </div>
    <p className="mt-2 text-xs text-slate-500">{metric.description}</p>
  </div>
);

export default ReputationCard;
